import { render, staticRenderFns } from "./ThSort.vue?vue&type=template&id=673af1ce"
import script from "./ThSort.vue?vue&type=script&lang=js"
export * from "./ThSort.vue?vue&type=script&lang=js"
import style0 from "./ThSort.vue?vue&type=style&index=0&id=673af1ce&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports